
import { Vue, Component, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';
import ImagePreviewModal from '@/views/supplyChain/platform/components/ImagePreviewModal.vue';

@Component({
  components: {
    ImagePreviewModal,
  },
})
export default class SalesOrderDetailModal extends Vue {
  visible = false;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  @Ref('imagePreviewModal')
  imagePreviewModal!: ImagePreviewModal;

  // 详情接口为嵌套结构，预置空对象避免模板取子字段报错
  detail: any = {
    base_info: {},
    receiver_info: {},
    purchase_summary: {},
    logistics_info: {},
  };

  productList: any[] = [];

  logisticsStatusMap: any = {
    1: '已发货',
    2: '签收',
  };

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: () => `共${this.pagination.total}条`,
    onChange: this.paginationChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  productColumns = [
    {
      title: '物料编号',
      dataIndex: 'commodity_code',
      align: 'center',
    },
    {
      title: '产品名称',
      dataIndex: 'commodity_name',
      align: 'center',
    },
    {
      title: '规格',
      dataIndex: 'specification',
      align: 'center',
      scopedSlots: { customRender: 'specification' },
    },
    {
      title: '数量/箱',
      dataIndex: 'quantityPerBox',
      align: 'center',
      scopedSlots: { customRender: 'quantityPerBox' },
    },
    {
      title: '下单箱数',
      dataIndex: 'package_quantity',
      align: 'center',
    },
    {
      title: '下单壶数',
      dataIndex: 'orderPots',
      align: 'center',
      scopedSlots: { customRender: 'orderPots' },
    },
    {
      title: '单价/壶',
      dataIndex: 'agent_price',
      align: 'center',
    },
    {
      title: '小计（元）',
      dataIndex: 'amount',
      align: 'center',
      scopedSlots: { customRender: 'subtotal' },
    },
  ];

  async open(record: any) {
    this.detail = {
      base_info: {},
      receiver_info: {},
      purchase_summary: {},
      logistics_info: {},
      ...(record || {}),
    };
    const res = await this.supplyService.getPlatDetail({ id: this.detail.id });
    if (res) {
      this.detail = { ...this.detail, ...res };
    }
    this.visible = true;
    this.getDetail();
  }

  async getDetail() {
    const res = await this.supplyService.getCommodityDetailByOrder({
      order_no: this.detail.base_info.order_no,
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
    });
    this.productList = res.list;
    this.pagination.total = res.total;
  }
  // 小计 = 单价/壶 * 下单壶数
  calcSubtotal(record: any) {
    const price = Number(record.pricePerPot) || 0;
    const pots = Number(record.orderPots) || 0;
    return (price * pots).toFixed(2);
  }

  viewDeliveryOrder() {
    const resourceList = this.detail.logistics_info.resource_no_map;
    const urls = resourceList ? Object.values(resourceList) : [];
    this.imagePreviewModal.open('发货单', urls || []);
  }

  onClose() {
    this.visible = false;
    this.detail = {
      base_info: {},
      receiver_info: {},
      purchase_summary: {},
      logistics_info: {},
    };
    this.productList = [];
    this.pagination.current = 1;
    this.pagination.total = 0;
    this.pagination.pageSize = 10;
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getDetail();
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = size;
    this.getDetail();
  }
}
